import store from "../../../store";
import glovo_export from './glovo_export.vue';

window.glovo_export =  new Vue({
    store,
    el: 'div#glovo_export',

    name : "glovo_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        glovo_export,
    }
});
